import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from './Logo';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0f1c]">
      {/* Header */}
      <nav className="bg-[#0a0f1c]/95 backdrop-blur-md border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Logo className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Quay Lại Trang Chủ
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Chính Sách Bảo Mật
          </h1>
          <p className="text-gray-500 mb-8">Cập nhật lần cuối: Tháng 2, 2026</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Giới Thiệu</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nhamy.us ("Chúng tôi", "Công ty") cam kết bảo vệ quyền riêng tư của bạn. Chính sách bảo mật này giải thích cách chúng tôi thu thập, sử dụng, tiết lộ và bảo vệ thông tin cá nhân của bạn khi bạn sử dụng trang web Nhamy.us ("Trang web").
              </p>
              <p className="text-gray-700 leading-relaxed">
                Nhamy.us hợp tác với nhiều tổ chức cho vay uy tín trên toàn quốc để kết nối bạn với các sản phẩm vay thế chấp phù hợp nhất.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Thông Tin Chúng Tôi Thu Thập</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi thu thập các loại thông tin sau:
              </p>

              <h3 className="text-lg font-medium text-gray-800 mb-2">2.1 Thông Tin Bạn Cung Cấp Trực Tiếp</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li><strong>Thông tin liên hệ:</strong> Họ tên, địa chỉ email, số điện thoại</li>
                <li><strong>Thông tin tài chính:</strong> Thu nhập ước tính, điểm tín dụng, tình trạng nợ</li>
                <li><strong>Thông tin bất động sản:</strong> Loại bất động sản, mục đích sử dụng, vị trí (mã vùng)</li>
                <li><strong>Thông tin khoản vay:</strong> Giá mua, tiền trả trước, mục đích vay</li>
                <li><strong>Thông tin khác:</strong> Tình trạng quân nhân/cựu chiến binh</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mb-2">2.2 Thông Tin Thu Thập Tự Động</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Địa chỉ IP và thông tin thiết bị</li>
                <li>Loại trình duyệt và hệ điều hành</li>
                <li>Các trang bạn truy cập và thời gian truy cập</li>
                <li>Nguồn giới thiệu (referral source)</li>
                <li>Cookie và công nghệ theo dõi tương tự</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Cách Chúng Tôi Sử Dụng Thông Tin</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi sử dụng thông tin của bạn để:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Kết nối bạn với các đối tác cho vay phù hợp</li>
                <li>Cung cấp báo giá lãi suất và thông tin sản phẩm vay</li>
                <li>Liên hệ với bạn về yêu cầu của bạn qua điện thoại, SMS, hoặc email</li>
                <li>Cải thiện dịch vụ và trải nghiệm người dùng</li>
                <li>Phân tích xu hướng sử dụng và hiệu suất trang web</li>
                <li>Tuân thủ các nghĩa vụ pháp lý và quy định</li>
                <li>Phát hiện và ngăn chặn gian lận</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Chia Sẻ Thông Tin</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi có thể chia sẻ thông tin của bạn với:
              </p>

              <h3 className="text-lg font-medium text-gray-800 mb-2">4.1 Đối Tác Cho Vay</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Khi bạn gửi yêu cầu báo giá, thông tin của bạn sẽ được chia sẻ với một hoặc nhiều tổ chức cho vay được cấp phép trong mạng lưới đối tác của chúng tôi. Mạng lưới này bao gồm các ngân hàng, công ty thế chấp, và tổ chức tài chính uy tín. Các đối tác này có thể liên hệ trực tiếp với bạn để thảo luận về các lựa chọn vay.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mb-2">4.2 Nhà Cung Cấp Dịch Vụ</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi có thể chia sẻ thông tin với các nhà cung cấp dịch vụ bên thứ ba hỗ trợ hoạt động kinh doanh của chúng tôi, bao gồm:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Nhà cung cấp dịch vụ lưu trữ và đám mây</li>
                <li>Công ty phân tích dữ liệu</li>
                <li>Nhà cung cấp dịch vụ email và SMS</li>
                <li>Nhà cung cấp dịch vụ hỗ trợ khách hàng</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mb-2">4.3 Yêu Cầu Pháp Lý</h3>
              <p className="text-gray-700 leading-relaxed">
                Chúng tôi có thể tiết lộ thông tin khi được pháp luật yêu cầu hoặc để bảo vệ quyền lợi hợp pháp của chúng tôi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Đồng Ý Liên Lạc (TCPA Disclosure)</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Bằng cách cung cấp số điện thoại của bạn và đồng ý với các điều khoản của chúng tôi, bạn đồng ý rõ ràng cho:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Nhamy.us và các đối tác cho vay liên hệ với bạn</li>
                <li>Nhận cuộc gọi và tin nhắn văn bản (SMS/MMS) về các sản phẩm vay</li>
                <li>Nhận tin nhắn thông qua hệ thống quay số tự động hoặc ghi âm trước</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Lưu ý quan trọng:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Sự đồng ý này không phải là điều kiện để mua hàng</li>
                <li>Cước tin nhắn và dữ liệu có thể áp dụng</li>
                <li>Bạn có thể từ chối nhận tin nhắn bất cứ lúc nào bằng cách trả lời "STOP"</li>
                <li>Để được hỗ trợ, trả lời "HELP" hoặc liên hệ support@nhamy.us</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Cookie và Công Nghệ Theo Dõi</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi sử dụng cookie và các công nghệ tương tự để:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Ghi nhớ tùy chọn của bạn</li>
                <li>Phân tích lưu lượng truy cập trang web</li>
                <li>Cá nhân hóa nội dung và quảng cáo</li>
                <li>Đo lường hiệu quả của các chiến dịch marketing</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Bạn có thể quản lý cookie thông qua cài đặt trình duyệt của mình. Tuy nhiên, việc vô hiệu hóa cookie có thể ảnh hưởng đến chức năng của trang web.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Bảo Mật Dữ Liệu</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Chúng tôi thực hiện các biện pháp bảo mật hợp lý để bảo vệ thông tin của bạn, bao gồm:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Mã hóa SSL/TLS cho tất cả các giao dịch dữ liệu</li>
                <li>Kiểm soát truy cập và xác thực</li>
                <li>Giám sát và phát hiện xâm nhập</li>
                <li>Đào tạo nhân viên về bảo mật dữ liệu</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Tuy nhiên, không có phương thức truyền dữ liệu qua internet nào là an toàn tuyệt đối.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Quyền Của Bạn</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tùy thuộc vào nơi bạn cư trú, bạn có thể có các quyền sau:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Quyền truy cập:</strong> Yêu cầu bản sao thông tin cá nhân của bạn</li>
                <li><strong>Quyền sửa chữa:</strong> Yêu cầu sửa chữa thông tin không chính xác</li>
                <li><strong>Quyền xóa:</strong> Yêu cầu xóa thông tin cá nhân của bạn</li>
                <li><strong>Quyền từ chối:</strong> Từ chối bán hoặc chia sẻ thông tin cá nhân</li>
                <li><strong>Quyền không phân biệt đối xử:</strong> Không bị phân biệt đối xử khi thực hiện các quyền của bạn</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Để thực hiện các quyền này, vui lòng liên hệ với chúng tôi tại support@nhamy.us.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Quyền Riêng Tư California (CCPA)</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nếu bạn là cư dân California, bạn có các quyền bổ sung theo Đạo luật Quyền riêng tư Người tiêu dùng California (CCPA), bao gồm:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Quyền biết thông tin cá nhân nào được thu thập</li>
                <li>Quyền biết thông tin có được bán hay tiết lộ hay không</li>
                <li>Quyền từ chối bán thông tin cá nhân</li>
                <li>Quyền xóa thông tin cá nhân</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Trẻ Em</h2>
              <p className="text-gray-700 leading-relaxed">
                Trang web của chúng tôi không dành cho người dưới 18 tuổi. Chúng tôi không cố ý thu thập thông tin cá nhân từ trẻ em. Nếu bạn là phụ huynh hoặc người giám hộ và biết rằng con bạn đã cung cấp thông tin cho chúng tôi, vui lòng liên hệ với chúng tôi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Liên Kết Bên Thứ Ba</h2>
              <p className="text-gray-700 leading-relaxed">
                Trang web có thể chứa các liên kết đến các trang web bên thứ ba. Chúng tôi không chịu trách nhiệm về các chính sách bảo mật hoặc nội dung của các trang web này. Chúng tôi khuyến khích bạn đọc chính sách bảo mật của mỗi trang web bạn truy cập.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Thay Đổi Chính Sách</h2>
              <p className="text-gray-700 leading-relaxed">
                Chúng tôi có thể cập nhật chính sách bảo mật này theo thời gian. Chúng tôi sẽ thông báo cho bạn về bất kỳ thay đổi quan trọng nào bằng cách đăng chính sách mới trên trang này và cập nhật ngày "Cập nhật lần cuối".
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">13. Liên Hệ</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nếu bạn có câu hỏi về Chính sách Bảo mật này hoặc muốn thực hiện các quyền của mình, vui lòng liên hệ:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700"><strong>Nhamy.us</strong></p>
                <p className="text-gray-700">Email: support@nhamy.us</p>
                <p className="text-gray-700 mt-2">Để từ chối nhận tin nhắn SMS: Trả lời "STOP" cho bất kỳ tin nhắn nào</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0d1424] border-t border-gray-800 py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm">
            © 2026 Nhamy.us. Bảo lưu mọi quyền.
          </p>
          <div className="flex justify-center gap-6 mt-4">
            <Link to="/terms" className="text-gray-400 hover:text-[#10b981] text-sm">Điều Khoản Dịch Vụ</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-[#10b981] text-sm">Chính Sách Bảo Mật</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
